module.exports = __webpack_public_path__ + "static/media/Lederhosen Guy.0be0ec41.jpg";